import AwaitedPropertyTimeoutException from '../exceptions/awaitedPropertyTimeoutException';
/**
 * Wait for a property to become available by repeatedly checking for its availability.
 * Default wait time is 500ms total.
 *
 * @param propertyName Name of the property to await
 * @param obj Object the property is in (e.g. window, document)
 * @param numberOfTries How many times should recursion happen before giving up?
 * @param delay How much time (in ms) should elapse between recursion?
 */
// eslint-disable-next-line @typescript-eslint/ban-types
export const awaitProperty = async (propertyName, obj, numberOfTries = 10, delay = 50) => new Promise((resolve, reject) => {
    // If it already exists, then resolve immediately
    // if (propertyName in obj && typeof obj[propertyName] !== 'undefined') {
    if (propertyName in obj && obj[propertyName]) {
        resolve(obj[propertyName]);
    }
    // Set a recursion depth counter
    let depth = 0;
    // Check every [delay]ms if it's available yet
    const interval = setInterval(() => {
        // if (propertyName in obj && typeof obj[propertyName] !== 'undefined') {
        if (propertyName in obj && obj[propertyName]) {
            // If it exists, then clear the interval and resolve
            clearInterval(interval);
            resolve(obj[propertyName]);
        }
        else {
            // Otherwise add to the depth counter
            depth += 1;
            // If we're too deep then fail
            if (depth > numberOfTries) {
                clearInterval(interval);
                reject(new AwaitedPropertyTimeoutException(propertyName, depth * numberOfTries));
            }
        }
    }, delay);
});
